/**
 * Custom JavaScript. Events documentation of the Focal theme: variant:changed, variant:added, cart:updated, cart:refresh
 * (cart:updated gives event.detail.cart, cart:refresh re-renders the cart and mini-cart).
 */

/**
 * ------------------------------------------------------------------------------------------------------------
 * BLACK FRIDAY GIFT TEST: automatically add (or remove) the hidden gift product when the cart reaches the threshold.
 * Only active between GIFT_START and GIFT_END. Outside of that window the script removes the gift from the cart,
 * hides the progress bar and hides the gift announcement message (the one that contains the word "подарък"),
 * so nothing has to be turned off by hand.
 * Test window: Sat 24.10.2026 00:00 to Tue 27.10.2026 23:59 (Sofia time).
 * The gift product must be ACTIVE and available on the Online Store sales channel for the add to work.
 * While it is a draft, the add fails silently and nothing happens.
 * The progress bar (settings: cart_free_shipping_threshold = 30) must use the same threshold.
 * ------------------------------------------------------------------------------------------------------------
 */
(function () {
  var GIFT_VARIANT_ID = 59124827521359;
  var THRESHOLD_CENTS = 3000;
  var GIFT_START = Date.parse('2026-10-23T21:00:00Z');
  var GIFT_END = Date.parse('2026-10-27T21:59:59Z');
  var busy = false;

  function isActive() {
    var now = Date.now();
    return now >= GIFT_START && now <= GIFT_END;
  }

  function hideOffer() {
    var style = document.createElement('style');
    style.textContent = 'free-shipping-bar, .shipping-bar { display: none !important; }';
    document.head.appendChild(style);

    document.querySelectorAll('announcement-bar-item').forEach(function (item) {
      if (item.textContent.toLowerCase().indexOf('подарък') !== -1) { item.remove(); }
    });
  }

  function failed() {
    try { return sessionStorage.getItem('gift-bf-failed') === '1'; } catch (e) { return false; }
  }

  function markFailed() {
    try { sessionStorage.setItem('gift-bf-failed', '1'); } catch (e) {}
  }

  function post(url, body) {
    return fetch(window.Shopify && Shopify.routes ? Shopify.routes.root + url : '/' + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  }

  function refresh() {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
  }

  function sync(cart) {
    if (busy || !cart || !cart.items) { return; }

    var giftLine = null;
    var counted = 0;

    cart.items.forEach(function (item) {
      if (item.variant_id === GIFT_VARIANT_ID) {
        giftLine = item;
      } else {
        counted += item.final_line_price;
      }
    });

    var qualifies = isActive() && counted >= THRESHOLD_CENTS;

    if (qualifies && !giftLine) {
      if (failed()) { return; }
      busy = true;

      post('cart/add.js', { items: [{ id: GIFT_VARIANT_ID, quantity: 1 }] })
        .then(function (response) { if (!response.ok) { markFailed(); } else { refresh(); } })
        .catch(markFailed)
        .then(function () { busy = false; });
    } else if (!qualifies && giftLine) {
      busy = true;

      post('cart/change.js', { id: giftLine.key, quantity: 0 })
        .then(refresh)
        .catch(function () {})
        .then(function () { busy = false; });
    } else if (qualifies && giftLine && giftLine.quantity !== 1) {
      busy = true;

      post('cart/change.js', { id: giftLine.key, quantity: 1 })
        .then(refresh)
        .catch(function () {})
        .then(function () { busy = false; });
    }
  }

  document.addEventListener('cart:updated', function (event) {
    sync(event.detail && event.detail.cart);
  });

  document.addEventListener('DOMContentLoaded', function () {
    if (!isActive()) { hideOffer(); }

    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(sync)
      .catch(function () {});
  });
})();